import createClient, { type Middleware } from "openapi-fetch";

import type { paths } from "./schema";

export type AccessTokenProvider = () => Promise<string | null>;

export function createAuthMiddleware(getAccessToken: AccessTokenProvider): Middleware {
  return {
    async onRequest({ request }) {
      const token = await getAccessToken();
      if (token !== null) {
        request.headers.set("Authorization", `Bearer ${token}`);
      }
      return request;
    },
  };
}

function resolveBaseUrl(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
}

export function createApiClient(getAccessToken: AccessTokenProvider) {
  const client = createClient<paths>({ baseUrl: resolveBaseUrl() });
  client.use(createAuthMiddleware(getAccessToken));
  return client;
}

export type ApiClient = ReturnType<typeof createApiClient>;
